export default __webpack_public_path__ + "static/media/Nihilistic Wristbands.21ebe112.jpg";